<template>
    <div>
        <div class="row w-100">
            <div class="col-md-4">
                <p class="m-0"><b>Location:</b> {{ invite.location.name }}</p>
                <p class="m-0"><i class="fa fa-map-marker-alt"></i> {{ invite.location.address }}</p>
            </div>

            <div class="col-md-4">
                <p class="m-0"><b>Sent:</b> {{ formattedDate }}</p>
                <p class="m-0"><b>Sent By:</b> {{ invite.sender ? invite.sender.name : invite.origin }}</p>
                <p class="m-0"><b>Type:</b> {{ checkCampaignType }}</p>
            </div>

            <div class="col-md-4">
                <p class="m-0"><b>Campaign:</b> {{ invite.campaign.name | capitalize }}</p>
                <p class="m-0"><b>Origin:</b> {{ invite.origin | capitalize }}</p>
                <p class="m-0" v-if="invite.review"><b>Exit:</b> {{ invite.review.origin | capitalize }}</p>
            </div>
        </div>

        <div class="row mt-3" v-if="invite.workflow_histories.length">
            <table class="table table-striped table-condensed">
                <thead>
                <tr>
                    <th>Type</th>
                    <th>Content</th>
                    <th class="nowrap">Send at</th>
                    <th class="nowrap">Sent at</th>
                    <th>
                        <template v-if="!isFailed">
                            <button class="btn btn-success btn-sm" data-toggle="tooltip" title="Start Workflow"
                                    :disabled="loading" @click="start" v-if="isStopped">
                                <i class="fa fa-btn fa-spinner fa-spin" v-if="loading"></i>
                                <i class="fa fa-play" v-else></i>
                            </button>

                            <button class="btn btn-danger btn-sm" data-toggle="tooltip" title="Stop Workflow"
                                    :disabled="loading" @click="stop" v-if="isInitiated || isScheduled">
                                <i class="fa fa-btn fa-spinner fa-spin" v-if="loading"></i>
                                <i class="fa fa-stop" v-else></i>
                            </button>
                        </template>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in invite.workflow_histories" :key="`workflow-history-${item.id}`">
                    <td>{{ item.type }}</td>
                    <td v-html="item.content"></td>
                    <td class="nowrap">{{ item.send_at | calendar }}</td>
                    <td class="nowrap">{{ item.sent_at | calendar }}</td>
                    <td>
                        <span class="badge badge-danger" v-if="isStopped && item.status.message === 'scheduled'">
                            stopped
                        </span>

                        <span :class="`badge badge-${item.status.color}`" v-else>
                            {{ item.status.message }}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>

        <div v-if="invite.review" class="m-1">
            <read-review :review="invite.review"></read-review>
        </div>
    </div>
</template>

<script>
    import ReadReview from '../reviews/ReadReview';

    export default {
        components: { ReadReview },
        props: ['invite', 'timezone'],

        data: () => ({
            loading: false
        }),

        mounted() {
            $('[data-toggle="tooltip"]').tooltip();
        },

        filters: {
            calendar(value) {
                let date;

                if (_.has(value, 'date')) {
                    date = moment.tz(value.date, value.timezone).tz(moment.tz.guess());
                }

                if (moment(value).isValid()) {
                    date = moment.tz(value, 'UTC').tz(moment.tz.guess());
                }

                if (date) {
                    if (
                        !date.isAfter(
                            moment()
                                .subtract(7, 'days')
                                .startOf('day')
                        )
                    ) {
                        return date.format('llll');
                    }

                    return date.calendar();
                }

                return value;
            }
        },

        computed: {
            formattedDate() {
                const dateFormat = 'L LT';
                let date;
                let timezoneTemp = 'MST';
                if (this.timezone){
                    timezoneTemp = this.timezone;
                }
                if (this.invite.sent_at) {
                    return moment.tz(this.invite.sent_at, timezoneTemp).format(dateFormat);
                }

                if (this.invite.status === 'failed') {
                    date = moment.tz(this.invite.send_at, timezoneTemp).format(dateFormat);
                    return `Failed to invite at ${date}`;
                }

                date = moment.tz(this.invite.send_at, timezoneTemp).format(dateFormat);
                return `This invite will be sent on ${date}`;
            },
            campaign() {
                return this.invite.campaign;
            },
            isPublic() {
                return this.campaign.type === 'public';
            },
            isCx() {
                return this.campaign.type === 'cx';
            },
            isNps() {
                return this.campaign.type === 'nps';
            },
            isWorkflow() {
                return this.campaign.type === 'workflow';
            },
            isInitiated() {
                return this.invite.status === 'initiated';
            },
            isScheduled() {
                return this.invite.status === 'scheduled';
            },
            isStopped() {
                return this.invite.status === 'stopped';
            },
            isFailed() {
                return this.invite.status === 'failed';
            },
            checkCampaignType() {
                if (this.isPublic) return 'Public Campaign';
                if (this.isCx) return 'Customer Experience Campaign';
                if (this.isNps) return 'Net Promoter Score Campaign';
                if (this.isWorkflow) return 'Workflow Campaign';
            }
        },

        methods: {
            loadTooltip() {
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip('dispose');
                    $('[data-toggle="tooltip"]').tooltip();
                });
            },
            async start() {
                this.loading = true;
                const { data } = await this.$http.put(
                    this.$laroute.route('api.invite.workflow.start', {
                        invite: this.invite.id
                    })
                );
                this.loading = false;
                this.$emit('change-status', data.status);
                this.loadTooltip();
            },
            async stop() {
                this.loading = true;
                await this.$http.put(
                    this.$laroute.route('api.invite.workflow.stop', {
                        invite: this.invite.id
                    })
                );
                this.loading = false;
                this.$emit('change-status', 'stopped');
                this.loadTooltip();
            }
        }
    };
</script>
